/** Guardas de ruta: sesión requerida y rol de administrador. */

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { PageLoader } from '@/components/ui';
import { useAuthStore } from '@/stores/authStore';

/** Exige sesión iniciada; recuerda a dónde iba el usuario para volver tras el login. */
export function RequireAuth() {
  const { isAuthenticated, isBootstrapping } = useAuthStore();
  const location = useLocation();

  if (isBootstrapping) return <PageLoader label="Restaurando tu sesión…" />;

  if (!isAuthenticated) {
    return <Navigate to="/ingresar" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

/** Exige rol de administrador. El backend lo valida igualmente en cada endpoint. */
export function RequireAdmin() {
  const { user, isBootstrapping } = useAuthStore();

  if (isBootstrapping) return <PageLoader />;
  if (!user?.is_admin) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}

/** Para /ingresar y /registro: quien ya tiene sesión no debería verlas. */
export function RedirectIfAuthenticated() {
  const { isAuthenticated, isBootstrapping } = useAuthStore();

  if (isBootstrapping) return <PageLoader />;
  if (isAuthenticated) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
